var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3678 31.5615L16.3671 31.5609C11.5289 27.1736 7.55348 23.5685 4.78156 20.1795C2.01537 16.7976 0.5 13.692 0.5 10.3125C0.5 4.81364 4.81364 0.5 10.3125 0.5C13.4236 0.5 16.4174 1.95072 18.3693 4.24292L18.75 4.68995L19.1307 4.24292C21.0826 1.95072 24.0764 0.5 27.1875 0.5C32.6864 0.5 37 4.81364 37 10.3125C37 13.692 35.4846 16.7976 32.7183 20.182C29.9554 23.5623 25.9969 27.1595 21.1802 31.5366L21.1336 31.579L21.1325 31.58L18.7513 33.7313L16.3678 31.5615Z",
    fill: "#3D536C",
    stroke: "#3D536C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/fav-icon.99171e1d3266cc780c275de6852ee41e.svg";
export { ForwardRef as ReactComponent };